import React from "react";
import { capitalize, Chip } from "@mui/material";
import {
  POST_GRID_PRINT_MAIL_API_STATUS,
  REMINDER_LOG_STATUS_COLOR_MAP,
} from "static/constants";
import {
  CancelOutlined,
  CheckOutlined,
  TimerOutlined,
  NotificationsOffOutlined,
} from "@mui/icons-material";

const ReminderStatus = ({ status, key }) => {
  const color = REMINDER_LOG_STATUS_COLOR_MAP[status];
  const renderIcon = {
    success: <CheckOutlined style={{ color: "#94BA33" }} />,
    warning: <TimerOutlined style={{ color: "#FF9800" }} />,
    info: <TimerOutlined style={{ color: "#0288d1" }} />,
    error: <CancelOutlined />,
    default: <NotificationsOffOutlined fontSize="small" />,
  };

  return status ? (
    <Chip
      variant="outlined"
      icon={renderIcon[color]}
      color={color}
      style={{
        ...(color === "success" && {
          borderColor: "#94BA33",
          color: "#94BA33",
        }),
        ...(color === "warning" && {
          borderColor: "#FF9800",
          color: "#FF9800",
        }),
      }}
      label={
        key === "letter"
          ? POST_GRID_PRINT_MAIL_API_STATUS[status]
          : capitalize(status)
      }
    />
  ) : (
    <span>—</span>
  );
};

export default ReminderStatus;
